var quantityConfigureController = {};

$(function () {
    quantityConfigureController.generateQuantity = generateQuantity;
    quantityConfigureController.addVersion = addVersion;
    quantityConfigureController.removeVersion = removeVersion;
    quantityConfigureController.updateVersion = updateVersion;

    // Constants
    var QUANTITYEF = 'QUANTITYEF';
    var QUANTITY_PER_VERSION_EF = 'QUANTITY_PER_VERSION_EF';
    var VERSIONNAMEEF = 'VERSIONNAMEEF';
    var VERSION_COUNT_EF = 'VERSION_COUNT_EF';
    var QUOTEINPUTDATA = 'QUOTEINPUTDATA';

    // Comet Action Constants
    var ADDVERSION = 'ADDVERSION';
    var REMOVE_VERSIONS = 'REMOVE_VERSIONS';
    var REMOVEVERSION = 'REMOVEVERSION';
    var UPDATE_VERSION = 'UPDATE_VERSION';

    function generateQuantity () {
        var content = '';
        var cquotedata = configureglobals.cquotedata;
        var error = common.validation.hasJobQuoteFieldMessagesFor(QUANTITYEF) || common.validation.hasJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF);
        var help = '';
        var jc = configureglobals.clpjc || configureglobals.cpjc;

        if (jc.showQtyTip) {
            help = tags.a('Help', 'javascript:help.tip(configureglobals.' + (configureglobals.clpjc !== undefined ? 'clpjc' : 'cpjc') + ',\'qtyTip\',\'' + TBGBOTip.QUANTITY + '\')', {
                id: 'qtyTip',
                cssClass: 'quoteHelp',
                tabindex: '-1',
                title: 'More Information'
            });
        }
        if (cquotedata.versions.length === 1) {
            content += help + tags.label(cquotedata.quantityLabel, {
                cssClass: 'config'
            });
        }
        if (jc.editQty == true || cquotedata.privilegedMode) {
            // QUANTITYEF accepts total-quantity when single version, or each-version-quantity when multiple versions
            var quantity = cquotedata.quantity ? cquotedata.quantity : '';
            var quantityPerVersion = cquotedata.quantityPerVersion ? cquotedata.quantityPerVersion : '';
            var versions = cquotedata.versions;

            if (cquotedata.versions.length > 1) {
                content += '<table class="version-quantity">';
                content += '<tr class="quantity-per"><td><label class="config">' + cquotedata.versionQuantityLabel + '</label></td><td>' + forms.ef(QUANTITY_PER_VERSION_EF, quantityPerVersion, {
                    size: 5,
                    cssClass: 'configField' + (error ? ' error' : ''),
                    onfocus: 'common.efFocus(\'' + QUANTITY_PER_VERSION_EF + '\',\'quantityDiv\', \'quantityFocus\')',
                    onblur: 'common.efBlur(\'' + QUANTITY_PER_VERSION_EF + '\',\'quantityDiv\', \'quantityFocus\')'
                }) + '</td></tr>';

                if (common.validation.hasJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF)) {
                	content += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF) + '</td></tr>';
                }

                content += '<tr class="total-v"><td><span>Number of Versions</span></td><td><div class="noEdit version-total">' + versions.length + '</div>'
                        + forms.ef(VERSION_COUNT_EF, versions.length, { type: 'hidden' }) + '</td></tr>';
                content += '<tr class="total-v-quantity"><td><span>' + cquotedata.quantityLabel + '</span></td><td><div class="noEdit version-total sum-quantity">'
                        + cquotedata.quantity + '<div></td></tr>';
                content += '</table>';
            } else {
                content += forms.ef(QUANTITYEF, quantity, {
                    size: 5,
                    cssClass: 'configField' + (error ? ' error' : ''),
                    onfocus: 'common.efFocus(\'' + QUANTITYEF + '\',\'quantityDiv\', \'quantityFocus\')',
                    onblur: 'common.efBlur(\'' + QUANTITYEF + '\',\'quantityDiv\', \'quantityFocus\')'
                });
                content += '<span id="quantityFocus" class="changeFocusButton"><!-- dynamic --></span>';
            }

            if (common.validation.hasJobQuoteFieldMessagesFor(QUANTITYEF)) {
                content += common.validation.generateJobQuoteFieldMessagesFor(QUANTITYEF);
            }

            var maxVersions = jc.maxVersions;
            if (maxVersions > 1 && (cquotedata.versions == null || maxVersions > cquotedata.versions.length)) {
                content += tags.a('Add Another Version', 'javascript:quantityConfigureController.addVersion()', {
                    cssClass: 'addVersion'
                });
            }

            if (cquotedata.versions.length > 1) {
                for (var i = 0; i < versions.length; i++) {
                    var version = versions[i];
                    content += '<div id="quantityDiv' + i + '" name="versionHolder" class="optionWrapperOn">';
                    content += (i == 0 ? help : '') + '<label class="config">' + version.label + ' Name</label>';
                    content += forms.ef(VERSIONNAMEEF + i, version.label !== version.name ? version.name : '', {
                        cssClass: 'configField versionName' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + (VERSIONNAMEEF + i) + '\',\'quantityDiv' + i + '\', \'quantityFocus' + i + '\')',
                        onblur: 'javascript:quantityConfigureController.updateVersion(' + i + ')'
                    });
                    content += '<span id="quantityFocus' + i + '" class="changeFocusButton"><!-- dynamic --></span>';
                    content += '<span id="versionDelete' + i + '" class="deleteVersion">' + tags.a('&nbsp;', 'javascript:quantityConfigureController.removeVersion(' + i + ')', {
                        id: 'deleteVersion' + i,
                        cssClass: 'deleteVersion',
                        title: 'Delete This Version'
                    }) + '</span>';
                    content += '</div>';
                }
            }
        } else {
            content += tags.div(cquotedata.quantity, {
                cssClass: 'noEdit'
            });
        }

        common.setOptionDiv('quantity', content);
    }

    function addVersion () {
        var versions = configureglobals.cquotedata.versions;

        var configChangeDetails = {
            context: 'addVersions',
            category: confUtil.OPTION_CHANGE,
            value: ''
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, ADDVERSION, function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
            growlMessages.showAll(cometRequest);
            quantityConfigureController.generateQuantity();
            common.ef = null;
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.send();
    }
    function removeVersion (index) {
        var versions = configureglobals.cquotedata.versions;
        var pluralize = configureglobals.cquotedata.versions.length == 2;

        var configChangeDetails = {
            context: 'removeVersion' + (pluralize ? 's' : ''),
            category: confUtil.OPTION_CHANGE,
            value: index
        };
        configureEvents.onCalcChanged(configChangeDetails);
        confirmPanel.confirm('Are you sure you want to remove this version?', function () {
            var cometRequest = comet.newRequest(chandler, pluralize ? REMOVE_VERSIONS : REMOVEVERSION, function (cometRequest) {
                common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
                growlMessages.showAll(cometRequest);
                quantityConfigureController.generateQuantity();
                common.ef = null;
                controller.getQuote(false, function () {
                    configureEvents.onQuoteUpdated(configChangeDetails);
                });
            });
            cometRequest.addObjectId(index);
            cometRequest.send();
        });
    }

    function updateVersion (index) {
        common.efBlur(VERSIONNAMEEF + index, 'quantityDiv' + index, 'quantityFocus' + index);
        var cometRequest = comet.newRequest(chandler, UPDATE_VERSION, function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
            growlMessages.showAll(cometRequest);
            quantityConfigureController.generateQuantity();
        });

        cometRequest.addObjectId(index);
        cometRequest.addFormField(VERSIONNAMEEF + index, false, document);
        cometRequest.send();
    }
});
